import { Box, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { useIntl } from 'react-intl';
import { immersightBlue } from '../../utils/colors';

const ImsOutlinedInput = styled(OutlinedInput)(() => ({
  borderRadius: 12,
  height: 36,
  paddingRight: '40px', 
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ddd',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ccc',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ccc',
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '0.6rem',
    color: '#555',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}));

const ImsSelect = ({ options, value, onChange, placeholderId, icon: Icon, multiple, ...props }: any) => {
  const intl = useIntl();
  const placeholderText = intl.formatMessage({ id: placeholderId });

  return (
    <Select
      {...props}
      multiple={multiple}
      displayEmpty
      value={value}
      onChange={onChange}
      input={<ImsOutlinedInput notched={false} label="" />}
      renderValue={(selected) => {
        if (!selected || (Array.isArray(selected) && selected.length === 0)) {
          return <Typography sx={{ color: '#999', fontSize: '0.8rem' }}>{placeholderText}</Typography>;
        }
        return Array.isArray(selected) ? selected.join(', ') : selected;
      }}
      sx={{
        '& .MuiSelect-icon': {
          color: '#999',
          right: '10px',
          transform: 'none !important', 
          transition: 'none !important',
        },
        '& .MuiSelect-select': {
          fontSize: '0.6rem',
          color: '#555',
          paddingLeft: '12px',
          paddingRight: '40px',
          display: 'flex',
          alignItems: 'center',
        },
      }}
      IconComponent={Icon} 
    >
      {options.map((option: string, idx: number) => {
        const isSelected = multiple ? value.includes(option) : value === option;

        return (
          <MenuItem 
            key={idx} 
            value={option} 
            sx={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center"
            }}
          >
            <Typography variant="body2">{option}</Typography>

            {/* Right-aligned selection indicator */}
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                border: `2px solid ${immersightBlue}`,
                backgroundColor: isSelected ? immersightBlue : "transparent",
                transition: "background-color 0.3s ease-in-out",
              }}
            />
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default ImsSelect;
